import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box } from '@mui/material';
import { formatDate } from '../../../../utils/formatDate';
import { ReactComponent as DownloadIcon } from '../../../../assets/images/download.svg';
import { serviceLocalStorage } from '../../../../utils/serviceLocalStorage';
import axios from 'axios';

export const SubscribersTableBody = ({ data, link }) => {
  const downloadFile = (id, name) => {
    axios.get(`${process.env.REACT_APP_API_URL}${link}${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${serviceLocalStorage.getAccessToken()}`
      }
    }).then((response) => {
      const href = URL.createObjectURL(response.data);

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  return (
      <TableBody data-testid="TableBody">
        {data?.map(item =>
          <TableRow
            key={item.id}
            data-testid="TableRow"
          >
            <TableCell>
              <Box width="150px">{formatDate(item.created_at, false)}</Box>
            </TableCell>

            <TableCell>
              <Box width="210px">{item.line_amount}</Box>
            </TableCell>

            <TableCell>
              <Box width="150px" sx={{ fontWeight: 500 }}>{item.file_name}</Box>
            </TableCell>

            <TableCell onClick={() => downloadFile(item.id, item.file_name)}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}>
                <DownloadIcon data-testid="DownloadIcon" />
              </Box>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
  );
};

SubscribersTableBody.propTypes = {
  data: PropTypes.array,
  link: PropTypes.string
};
